// extracted by mini-css-extract-plugin
export default {"buttonsDivider":"src-signer-app-signature-modal-common-buttons-divider-module__buttonsDivider--_0B3f"};